module.exports = __webpack_public_path__ + "img/phones-ios.d9619664.png";